export interface WaasStorage {
    get(queueId: string): string;
    remove(queueId: string): void;
    set(queueId: string, token: string | null): boolean;
    test(): boolean;
}

export const waasLocalStoragePrefix = '@openticket:waas:v1:queue' as const;
export const waasLocalStorageTestKey = '__test__localstorage__availability__' as const;
export const waasLocalStorageTestValue = '__test__localstorage__availability__value__' as const;

export function createWaasStorage(): WaasStorage {
    const storage: WaasStorage = {
        get(queueId: string): string {
            try {
                return (
                    localStorage.getItem(waasLocalStorageKeyFor(queueId)) || ''
                );
            } catch (_) {
                return '';
            }
        },
        remove(queueId: string): void {
            try {
                // This is allowed to remove the empty queueId, even if it should not have it.
                // Due to the buildup of the key, this will not lead to (legitimate) collisions.
                localStorage.removeItem(waasLocalStorageKeyFor(queueId));
            } catch (_) {
                // No-op
            }
        },
        set(queueId: string, token: string | null): boolean {
            if (!queueId) {
                return false;
            }

            if (!token) {
                storage.remove(queueId);

                return true;
            }

            try {
                localStorage.setItem(waasLocalStorageKeyFor(queueId), token);
            } catch (_) {
                return false;
            }

            return true;
        },
        test(): boolean {
            try {
                const value = `${waasLocalStorageTestValue}__${Date.now().toFixed(
                    0
                )}`;

                if (!storage.set(waasLocalStorageTestKey, value)) {
                    return false;
                }

                return storage.get(waasLocalStorageTestKey) === value;
            } finally {
                storage.remove(waasLocalStorageTestKey);
            }
        },
    };

    return storage;
}

export function waasLocalStorageKeyFor(
    queueId: string,
    type = 'token'
): string {
    return `${waasLocalStoragePrefix}:${queueId}:${type}`;
}
